import React from "react";

const TabManager = ({ activeTab, setActiveTab, tabItems }) => {
  const handleTab = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="w-fit h-[50px] flex text-base font-medium rounded-[10px] bg-darkgray">
      {tabItems?.map((val, index) => {
        return (
          <div
            key={index}
            onClick={() => handleTab(val.key)}
            className={`h-[50px] min-w-[170px] max-w-[170px] rounded-[10px] flex items-center justify-center cursor-pointer
                ${
                  activeTab === val.key
                    ? "bg-white border-[1.5px] border-bordergray"
                    : "text-textgray"
                }`}
          >
            {val.title}
          </div>
        );
      })}
    </div>
  );
};

export default TabManager;
